import { useMutation } from '@tanstack/react-query';
import { regenerateRecoveryCodes } from '@/api/auth.api';

/**
 * Replace the signed-in user's recovery codes from the account page (MYN-241).
 * The new codes are the mutation's `data`; a failure is reported inline by the
 * confirm dialog that triggered it, which stays open.
 */
export function useRegenerateRecoveryCodes() {
  return useMutation({ mutationFn: () => regenerateRecoveryCodes() });
}
